'use es6';

import { AD_NETWORK_FACEBOOK, AD_OBJECT_AD_CAMPAIGN } from 'reference-resolvers/constants/ReferenceObjectTypes';
import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
import { ADS_FACEBOOK_CAMPAIGNS } from 'reference-resolvers/constants/CacheKeys';
import { createFetchAdsObjectSearchPageForNetwork, createFetchAdsObjectsByIdsForNetwork, fetchAdsObjectsByIdsForNetwork, fetchAdsObjectSearchPageForNetwork } from 'reference-resolvers/api/AdsEntityApi';
export const createAdsFacebookCampaignsReferenceResolver = options => createBatchedReferenceResolver(Object.assign({
  cacheKey: ADS_FACEBOOK_CAMPAIGNS,
  createFetchByIds: opts => createFetchAdsObjectsByIdsForNetwork(opts)(AD_NETWORK_FACEBOOK, AD_OBJECT_AD_CAMPAIGN),
  createFetchSearchPage: opts => createFetchAdsObjectSearchPageForNetwork(opts)(AD_NETWORK_FACEBOOK, AD_OBJECT_AD_CAMPAIGN),
  fetchByIds: fetchAdsObjectsByIdsForNetwork(AD_NETWORK_FACEBOOK, AD_OBJECT_AD_CAMPAIGN),
  fetchSearchPage: fetchAdsObjectSearchPageForNetwork(AD_NETWORK_FACEBOOK, AD_OBJECT_AD_CAMPAIGN)
}, options));
export default createAdsFacebookCampaignsReferenceResolver();